import * as actionTypes from 'redux/actions'

const initialState = {
  loggedIn: false
}

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...state,
        ...action.payload,
        loggedIn: action.payload.state
      }
    }
    case actionTypes.GET_ACCOUNT: {
      return {
        ...state,
        user: action.payload
      }
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        loggedIn: false
      }
    }
    default: {
      return state
    }
  }
}

export default sessionReducer
